<template lang="pug">
div
  div.text-md.font-medium.neutral700--text {{ $t('no_show_reminder_template') }}
  div.text-sm.font-medium.neutral500--text.mt-1 {{ $t('no_show_reminder_template_desc') }}

  v-row(no-gutters)
    v-col(cols="12" sm="6")
      div.text-sm.font-semibold.neutral500--text.mt-8 {{ $t('current_template') }}
      v-card.message-preview-border.mt-2.round-xl(outlined)
        v-row(no-gutters justify="center")
          v-col.pa-3(cols="6")
            div.text-sm.font-normal(:class="formattedMessage ? 'neutral700--text' : 'neutral500--text'" style="white-space: pre-wrap;" v-html="formattedMessage ? formatInput(formattedMessage) : $t('current_template_placeholder')")
      div.mt-4(align="end")
        v-btn.button-md(color="neutral700" dark depressed @click="openEditMessageDialog = true") {{ $t('edit_template') }}
  
  .dialogs
    edit-message-template(v-if="openEditMessageDialog" :open.sync="openEditMessageDialog" @saving="saveData($event)" :templateMessage="message")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EditMessageTemplate from '@/components/clinic/dialogs/EditMessageTemplate.vue'

export default {
  name:'AbsentReminderTemplate',
  components: { EditMessageTemplate },
  props: ['absentReminder'],
  data () {
    return {
      openEditMessageDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    message: {
      get () {
        return this.absentReminder
      },
      set (val) {
        this.$emit('update:absentReminder', val)
      }
    },
    formattedMessage () {
      if (this.message) {
        let message = this.message
        message = message.split('{{name}}').join('Sarah Danial')
        message = message.split('{{doctor}}').join('Dr Jamal')
        message = message.split('{{service}}').join('General Consultation')
        message = message.split('{{date}}').join('12 Jan 2023')
        message = message.split('{{time}}').join('01.30 PM')
        message = message.split('{{appointment_link}}').join('https://clinic.yezza.co/appointment/101')
        message = message.split('{{pre_appt_instruction}}').join('1. Drink water and do not urinate before your ultrasound scan. Having water in your bladder will help the Sonographer to see your baby more clearly. \n2. We recommend a two-piece outfit so we can access your abdomen without you removing your clothing.')      
        message = message.split('{{post_appt_instruction}}').join('1. Get plenty of rest as much as possible to cope with tiredness and fatigue. \n2. Avoid raw or undercooked foods in your daily meal.')   
        return message
      }
      return this.message
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    saveData (message) {
      this.$axios.patch(`/clinics/${this.company.slug}`, { absent_reminder: message || null })
        .then(resp => {
          this.openEditMessageDialog = false
          this.message = resp.data.absent_reminder
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    formatInput(string) {
      string = String(string);
      
      //-----> for bold text
      let bold = string.split(" ").map((word) =>
      {
        if (/\*/.test(word) && !/^\**$/.test(word))
          if (/(^(~\*)|^(_\*)|^\*)(.*)(\*$|(\*_)$|(\*\W)$)/.test(word))
            return word.replace(/\*([^\r\n]+)\*/g, "<b>$1</b>")
          else if (/[_*~]\*(.*)\*[~*_]/.test(word))
            return word.replace(/\*([^*][^\r\n]+[^*])\*/g, "<b>$1</b>");
        return word;
      }).join(" ");

      //-----> for italic text 
      let italic = bold.split(" ").map((word) =>
      {
        if (/_/.test(word) && !/^_+$/.test(word))
        if (/(^~_|^_<.*>|^_\*|^_)(.*)(_$|(_<.*>)$|(_\*)$|(_\W)$)/.test(word))
          return word.replace(/_([^\r\n]+)_/g, "<i>$1</i>");
        else if (/(~|_|\*|<.*>)_(.*)_(<.*>|\*|~|_)/.test(word))
          return word.replace(/_([^_][^\r\n]+[^_])_/g, "<i>$1</i>");
        return word;
      }).join(" ");
      
      //----->for strikethrough/deleted text 
      let strikethrough = italic.split(" ").map((word) =>
      {
        if (/~/.test(word) && !/^~+$/.test(word))
          if (/(^_~|^~<.*>|^\*~|^~)(.*)(~$|(~_)$|(~<.*>)$|(~\*)$|(~\W)$)/.test(word))
            return word.replace(/~([^\r\n]+)~/g, "<del>$1</del>")
          else if (/(~|_|\*|<.*>)~(.*)~(<.*>|\*|~|_)/.test(word))
            return word.replace(/~([^~][^\r\n]+[^~])~/g, "<del>$1</del>");
        return word;
      }).join(" ");
      
      
      
      //-----> for underlined text
      var underline = strikethrough.split(" ").map(function(word)
      {
        if (/%/.test(word) && !/^%+$/.test(word))
          if (/(^_%|^~%|^%<.*>|^\*%|^%)(.*)(%$|(%~)$|(%_)$|(%<.*>)$|(%\*)$|%\W+$)/.test(word))
            return word.replace(/%([^\r\n]+)%/g, "<u>$1</u>")
          else if (/(%|~|_|\*|<.*>)%(.*)%(<.*>|\*|~|%|_)/.test(word))
            return word.replace(/%([^%][^\r\n]+[^%])%/g, "<u>$1</u>");
        return word;
      }).join(" ");
      
      
      
      //-----> for monospace text
      var monospace = underline.split(" ").map(function(word)
      {
        if (/```/.test(word))
          if (/```(.|\n|\r)*(.+)(.|\n|\r])*```/.test(word)) 
            return word.replace(/```((.|\n|\r)*(.*)(\r|\n|.)*)```/g, `<span style="font-family: 'Courier New', Courier, monospace">$1</span>`);
        return word;
      }).join(" ");
        
      var formatted = monospace;
      
      //-----> for bold sentence formatting
      if (/\*(.*)\*/.test(formatted))
        formatted = formatted.replace(/(^|[\s_>~%`])\*([^\s\r\n]+[^*\n\r]+[^\s\r\n]+)\*([\W_\r\n\s]|$)/g, "$1<b>$2</b>$3");


      //-----> for italic sentence formatting 
      if (/_(.*)_/.test(formatted))
        formatted = formatted.replace(/(^|[\s>~%`*])_([^\s\r\n]+[^_\n\r]+[^\s\n\r]+)_([\W_\s\r\n]|$)/g, "$1<i>$2</i>$3");
      
      
      //-----> for strikethrough sentence formatting 
      if (/~(.*)~/.test(formatted))
        formatted = formatted.replace(/(^|[\s>%`*_])~([^\s\r\n]+[^~\r\n]+[^\r\n\s]+)~([\W_\s\r\n]|$)/g, "$1<del>$2</del>$3");
      
      
      //-----> for underline sentence formatting 
      if (/%(.*)%/.test(formatted))
        formatted = formatted.replace(/(^|[\s>~`*_])%([^\s\r\n]+[^%\r\n]+[^\r\n\s]+)%([\W_\s\r\n]|$)/g, "$1<u>$2</u>$3");
    
    
      //-----> for monospace sentence formatting
      var counter = 0;
      if (/```/.test(formatted))
      {
        var i = 0;
        formatted = formatted.split(" ");
        formatted = formatted.map(function(word)
        {
          //tempArr[i+1] handles case where input is like this: ``` ``` with no characters between back ticks
          if (!/<code>/.test(word))
            if (/```/.test(word) && formatted[i+1] != "```")
            {
              i++; counter++;
              if (counter % 2 != 0) 
                return word.replace("```", "<code>");
              else
                return word.replace("```", "</code>");
            } i++; 
          return word;
        }).join(" ");

        //handles case where there are no closing back ticks
        if (counter % 2 == 1)
        {
          formatted = formatted.split(" ");
          for (i = formatted.length-1; i >= 0; i--)
            if (/<code>/.test(formatted[i]))
            {
              formatted[i] = formatted[i].replace(/<code>/, "```");
              break;
            }
          formatted = formatted.join(" ");
        }
      }
      return formatted;
    },
  },
}
</script>

<style>
.message-preview-border {
  border: var(--v-basic500) solid 1px;
}
</style>